var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNumberFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.212 16.25h4.368l-.29 2H7.931l-.44 3.137a1 1 0 01-1.981-.278l.402-2.859H3.25a1 1 0 110-2h2.943l1.194-8.5H5.75a1 1 0 110-2h1.918l.442-3.14a1 1 0 111.98.28l-.402 2.86h6.38l.442-3.14a1 1 0 011.98.28l-.402 2.86h2.662a1 1 0 010 2h-2.943l-1.195 8.5h1.638a1 1 0 110 2h-1.919l-.44 3.137a1 1 0 01-1.981-.278L15.787 7.75h-6.38l-1.195 8.5z",
    fill: "currentColor"
  })));
}
export default SvgNumberFill;